import React from "react";
import style from "./ContentRightsConfirmation.module.css";

// Creators must confirm they hold distribution rights before any content
// (movie, series, season, podcast, short clip, ...) can be submitted.
// Admins never see this, so isCreator() gates both the UI and handleSubmit.
export const isCreator = () => localStorage.getItem("role") === "Creator";

export const CONTENT_RIGHTS_ERROR =
  "Please confirm the Content Rights Confirmation before publishing";

const ContentRightsConfirmation = ({ checked, onChange, showError }) => {
  // HARDCODED, on request: the brand name and the IOPGC release form are shown
  // to every tenant, not resolved per tenant. BrushTV creators therefore also
  // see "GRIEF TV | IOPGC" and are asked for an IOPGC form. Revisit before
  // onboarding another tenant - this is a consent notice, so the wording should
  // name the platform the creator is actually publishing to.
  if (!isCreator()) return null;

  return (
    <label
      className={`${style.rightsBox} ${showError && !checked ? style.rightsBoxError : ""}`}
    >
      <input
        type="checkbox"
        className={style.rightsCheckbox}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={style.rightsText}>
        <strong>Content Rights Confirmation:</strong> By submitting this video, I
        confirm that I own or have obtained all necessary rights, releases, and
        permissions from identifiable participants and other rights holders to
        distribute this content on GRIEF TV | IOPGC, including through its
        website, streaming applications, and subscription services. I agree to
        provide a completed IOPGC Guest Appearance and Content Release form
        signed by any guests appearing in the video upon request.
      </span>
    </label>
  );
};

export default ContentRightsConfirmation;
